import React, { useEffect, useState, useContext } from "react";
import Header from "../header/Header";
import { FaArrowRightLong } from "react-icons/fa6";
function Pateintcareplan() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [duration, setDuration] = useState(1);
  const [pricePerMonth] = useState(500);

  const handleDurationChange = (amount) => {
    const newDuration = duration + amount;
    if (newDuration > 0) {
      setDuration(newDuration);
    }
  };

  const totalPrice = duration * pricePerMonth;
  return (
    <>
      <Header></Header>
      <div class="ssimg1">
        <center>
          <h2>
            <b class="text-dark">
              <br></br>
              <br></br>
              <br></br>
              <br></br>Patient Care Plan
            </b>
          </h2>
        </center>
      </div>
      <div class="signature-background22">
        <div class="container">
          <br></br>
          <center>
            <h2>
              <b class="text-white">Service Overview</b>
            </h2>
          </center>
          <br></br>
          <center>
            <div class="row">
              <div class="col-sm-4">
                <div class="violetgr">
                  <div class="container">
                    <img
                      src="../style/img/resp/emicon1.png"
                      class="fdicon"
                    ></img>
                    <br></br>
                    <p class="iconh">Comprehensive Assessments</p>
                    <center>
                      <p class="iconp">
                        <b class="text-dark">
                        In-depth reviews of medical history to set personalized care goals.
                        </b>
                      </p>
                    </center>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="violetgr">
                  <div class="container">
                    <img
                      src="../style/img/resp/ssicon2.png"
                      class="fdicon"
                    ></img>
                    <br></br>
                    <p class="iconh">Tailored Care Plans</p>
                    <center>
                      <p class="iconp">
                        <b class="text-dark">
                        Customized treatment strategies for effective management of chronic conditions.
                        </b>
                      </p>
                    </center>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="violetgr">
                  <div class="container">
                    <img
                      src="../style/img/resp/emicon3.png"
                      class="fdicon"
                    ></img>
                    <br></br>
                    <p class="iconh">Ongoing Support & Education</p>
                    <center>
                      <p class="iconp">
                        <b class="text-dark">
                        Continuous monitoring and resources to empower families in managing health at home.
                        </b>
                      </p>
                    </center>
                  </div>
                </div>
              </div>
            </div>
          </center>
          <br></br>
          <br/>

          <center>
            <h2>
              <b class="text-white">Customization Options</b>
            </h2>
          </center>
          <br></br>
          <center>
            <div class="viosq">
              <div class="container">
                <form
                  class="booking-form"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div class="form-group11">
                    <label class="boxresd">Duration Selector:</label>
                    <div
                      class="diaginput"
                      style={{ position: "relative", marginLeft: "10px" }}
                    >
                      <span
                        class="subtraction text-dark"
                        onClick={() => handleDurationChange(-1)}
                        style={{
                          position: "absolute",
                          left: 20,
                          width: "20px",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          fontWeight: "bold",
                        }}
                      >
                        -
                      </span>
                      <input
                        class="booktestdur"
                        name="duration"
                        value={`${duration} month${duration > 1 ? "s" : ""}`}
                        readOnly
                        style={{
                          textAlign: "center",
                          width: "100%",
                          padding: "0 40px",
                        }}
                      />
                      <span
                        class="addition text-dark  booktestadd"
                        onClick={() => handleDurationChange(1)}
                        style={{
                          position: "absolute",
                          right: 20,
                          bottom: "0px",
                          width: "20px",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          fontWeight: "bold",
                        }}
                      >
                        +
                      </span>
                    </div>
                  </div>
                  <div class="form-group11">
                    <label class="boxresd">Price:</label>
                    <div class="diaginput" style={{ position: "relative" }}>
                      <input
                        class="booktestdur"
                        style={{ width: "300px" }}
                        type="number"
                        name="totalPrice"
                        value={totalPrice}
                        readOnly
                      />
                    </div>
                      </div>
                      </form>
                <br></br>       
                <center>
                  <button class="custom-btn1 btn-3">
                    <span class="btntexty bookingbtn">Book Now</span>
                  </button>
                </center>
              </div>
            </div>
          </center>
          <br></br>
          <br></br>
          <center>
            {" "}
            <h2>
              <b class="text-white">Service in Detail</b>
            </h2>
          </center>
          <br></br>

          {/* //advantages// */}
          <center>
            <div class="row">
              <div class="col-sm-4">
                <div class="violetgr">
                  <div class="container">
                    <img
                      src="../style/img/resp/armicon1.png"
                      class="fdicon"
                    ></img>
                    <br></br>
                    <p class="iconh">Comprehensive Medical Assessment</p>
                    <center>
                      <p class="iconp">
                        <b class="text-dark">
                        In-depth review of medical history to set personalized care goals.
                        </b>
                      </p>
                    </center>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="violetgr">
                  <div class="container">
                    <img
                      src="../style/img/resp/assicon2.png"
                      class="fdicon"
                    ></img>
                    <br></br>
                    <p class="iconh">Personalized Treatment & Nursing Care Plan</p>
                    <center>
                      <p class="iconp">
                        <b class="text-dark">
                        Customized care strategies for chronic disease management.
                        </b>
                      </p>
                    </center>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="violetgr">
                  <div class="container">
                    <img
                      src="../style/img/resp/assicon3.png"
                      class="fdicon"
                    ></img>
                    <br></br>
                    <p class="iconh">Palliative & Rehabilitation Care</p>
                    <center>
                      <p class="iconp">
                        <b class="text-dark">
                        Specialized plans for comfort
                         and recovery in complex cases.
                        </b>
                      </p>
                    </center>
                  </div>
                </div>
              </div>
            </div>
          </center>
          <br></br>
          <br></br>

          <center>
            <div class="row">
              <div class="col-sm-6">
                <div class="violetgr">
                  <div class="container">
                    <img
                      src="../style/img/resp/assicon4.png"
                      class="fdicon"
                    ></img>
                    <br></br>
                    <p class="iconh">Continuous Monitoring</p>
                    <center>
                      <p class="iconp">
                        <b class="text-dark">
                        Regular health checks and consultations
                         to adjust treatment as needed.
                        </b>
                      </p>
                    </center>
                  </div>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="violetgr">
                  <div class="container">
                    <img
                      src="../style/img/resp/advicon4.png"
                      class="fdicon"
                    ></img>
                    <br></br>
                    <p class="iconh">Education for Patients & Families</p>
                    <center>
                      <p class="iconp">
                        <b class="text-dark">
                        Equipping families with essential knowledge for effective home care.
                        </b>
                      </p>
                    </center>
                  </div>
                </div>
              </div>
            </div>
          </center>
          <br></br>
        </div>
      </div>
    </>
  );
}

export default Pateintcareplan;
